import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/Routes/Routes";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import styles from './preferences.module.css';
import "../../assets/fonts/fonts.css"
import PreferencesType from "../../components/PreferencesType/PreferencesType";
import PreferencesGenre from "../../components/PreferencesGenre/PreferencesGenre";
import PreferencesReleaseDate from "../../components/PreferencesReleaseDate/PreferencesReleaseDate";
import PreferencesCountry from "../../components/PreferencesCountry/PreferencesCountry";
import PreferencesRating from "../../components/PreferencesRating/PreferencesRating";
import ServerRequest from "../../serverRequests/ServerRequest";
import Loader from "../../components/Loader/Loader";
import {useDispatch} from "react-redux";
import {getGeneratedMovies} from "../../store/slices/generatedMovie";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";

const Preferences = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPreferences, setSelectedPreferences] = useState({
    type: "",
    genre: [],
    genreLocal: [],
    releaseDate: [],
    country: [],
    ratingIMDb: '',
  });
  const [isUnselectedRequiredCategory, setIsUnselectedRequiredCategory] =
    useState({
        type: false,
        genre: false,
      }
    );
  const userHash = localStorage.getItem("userHash");
  const userPhone = localStorage.getItem("userPhone");
  const dispatch = useDispatch();
  const [isGeneratedLimit, setIsGeneratedLimit] = useState(false);
  const usedAttemptsDaily = localStorage.getItem("generatedAttemptsDaily");
  const [isCountryError, setIsCountryError] = useState(false);
  const btnRef = useRef(null);


  useEffect(() => {
    scrollToTop();
  }, []);


  useEffect(() => {
    if (usedAttemptsDaily === "5") {
      setIsGeneratedLimit(!isGeneratedLimit);
    }
  }, [usedAttemptsDaily]);


  const scrollToTopDelay = () => {
    return new Promise((resolve) => {
      const checkIfScrolledToTop = () => {
        const isAtTop = window.scrollY === 0;
        if (isAtTop) {
          resolve();
        } else {
          requestAnimationFrame(checkIfScrolledToTop);
        }
      };

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      checkIfScrolledToTop();
    });
  };


  useEffect(() => {
    const {releaseDate} = selectedPreferences;

    if (releaseDate.length === 0) return;

    const noEmptyDatesArr = [...new Set(releaseDate.filter(item => item.trim() !== ""))];

    if (JSON.stringify(noEmptyDatesArr) !== JSON.stringify(releaseDate)) {
      setSelectedPreferences(prev => ({...prev, releaseDate: noEmptyDatesArr}));
      return;
    }

    if (noEmptyDatesArr.length === 2) {
      const sortedDatesArr = [...noEmptyDatesArr].sort((a, b) => a.localeCompare(b));

      if (JSON.stringify(sortedDatesArr) !== JSON.stringify(releaseDate)) {
        setSelectedPreferences(prev => ({...prev, releaseDate: sortedDatesArr}));
      }
    }
  }, [selectedPreferences.releaseDate]);


  const handleGenerateMovieData = async () => {
    if (selectedPreferences.type === "") {
      await scrollToTopDelay();
      setIsUnselectedRequiredCategory(prev => (
        {...prev, type: true}
      ));
    }

    if (selectedPreferences.genreLocal.length < 1) {
      await scrollToTopDelay();
      setIsUnselectedRequiredCategory(prev => (
        {...prev, genre: true}
      ));
    }

    await animateButtonPress(btnRef, styles.pressed);

    if (selectedPreferences.type !== "" && selectedPreferences.genre.length > 0) {
      setIsLoading(true);

      const {releaseDate, country, ratingIMDb} = selectedPreferences;

      const requestData = {
        type: selectedPreferences.type,
        genre: Array.from(
          new Set(selectedPreferences.genre
            .map(gnr => gnr[selectedPreferences.type]))
        )
      };

      if (releaseDate.length > 0) {
        requestData.releaseDate = releaseDate;
      }

      if (country.length > 0) {
        requestData.country = country;
      }
      if (ratingIMDb !== "") {
        requestData.ratingIMDb = ratingIMDb;
      }

      const serverData = await ServerRequest.createMovieData(requestData, userHash, userPhone);
      const parsedServerData = await serverData.json();

      if (parsedServerData.code === 200) {
        dispatch(getGeneratedMovies(parsedServerData.movies));

        if (parsedServerData['generation_attempts'] !== null) {
          localStorage.setItem("generatedAttemptsDaily", parsedServerData['generation_attempts']);
        }

        navigate(Routes.movies);
        setIsLoading(false);
      } else if (
        parsedServerData.code === 405 ||
        parsedServerData.code === 404 ||
        parsedServerData.code === 401 ||
        parsedServerData.code === 500 ||
        parsedServerData.code === 504
      ) {
        setIsLoading(false);
      }
    }
  };


  return (
    <section className={styles["section_wrapper"]}>
      <Loader isLoading={isLoading}/>
      <p className={styles.title}>
        {texts.preferences["title"]}
      </p>
      <PreferencesType selectedPreferences={selectedPreferences}
                       setSelectedPreferences={setSelectedPreferences}
                       isUnselectedRequiredCategory={isUnselectedRequiredCategory}
                       setIsUnselectedRequiredCategory={setIsUnselectedRequiredCategory}/>
      <PreferencesGenre selectedPreferences={selectedPreferences}
                        setSelectedPreferences={setSelectedPreferences}
                        isUnselectedRequiredCategory={isUnselectedRequiredCategory}
                        setIsUnselectedRequiredCategory={setIsUnselectedRequiredCategory}/>
      <PreferencesReleaseDate selectedPreferences={selectedPreferences}
                              setSelectedPreferences={setSelectedPreferences}/>
      <PreferencesCountry selectedPreferences={selectedPreferences}
                          setSelectedPreferences={setSelectedPreferences}
                          handleCountryError={setIsCountryError}/>
      <PreferencesRating selectedPreferences={selectedPreferences}
                         setSelectedPreferences={setSelectedPreferences}/>
      <button ref={btnRef}
              className={`
                          ${!isGeneratedLimit ? styles['button-generate']
                : styles['button-generate-disabled']}
                        ${isCountryError ? styles['button-generate-disabled'] : ""}
                        `}
              onClick={handleGenerateMovieData}>
        {texts.preferences["btn-generate"]}
      </button>
    </section>
  )
}

export default Preferences;